document.addEventListener('click', function(event) {
  const opener = event.target.closest('[data-ffbc-open]');
  if (opener) {
    const dialog = document.getElementById(opener.dataset.ffbcOpen);
    if (dialog && !dialog.open) {
      dialog.showModal();
      const previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      dialog.addEventListener('close', function() {
        document.body.style.overflow = previousOverflow;
        opener.focus();
      }, { once: true });
    }
    return;
  }
  const closer = event.target.closest('[data-ffbc-close]');
  if (closer) closer.closest('dialog').close();
  if (event.target.matches('.ffbc-dialog')) {
    const rect = event.target.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
  }
});